import { connect } from 'react-redux';
import Component from './HB1416Tracker.component';
import { getAvatars, getCurrentRosterYear, initStudentsRoster } from '../StudentRoster/+store/studentRoster';
import { getSchools } from '../Settings/+store/SchoolSettings';
import { resetFilters } from '../common/+store/FilterBox';
import {
  getHb1416Tracker,
  updateHb1416Tracker,
  generateAEP,
  generateAllAEPs,
  matchTiaDesignations,
  selectStudent,
} from './+store';

const mapStateToProps = (state) => {
  const slice = state.modules.HB1416Tracker.hb1416Tracker;
  const { profile } = state.modules.Auth.auth;
  const currentSnapshotYear = getCurrentRosterYear();
  const rosterByYear = state.modules.StudentRoster.studentRoster.roster;
  const students = (rosterByYear && rosterByYear[currentSnapshotYear]) || {};

  return {
    profile,
    snapshotYear: currentSnapshotYear,
    students,
    worklist: slice.worklist || {},
    schoolList: state.modules.Settings.schoolSettings.schoolList || {},
    avatars: state.modules.StudentRoster.studentRoster.avatars,
    loading: !!slice.loadingMsg,
    loadingMsg: slice.loadingMsg,
    loadingRoster: !!state.modules.StudentRoster.studentRoster.loadingMsg,
    selectedStudentId: slice.selectedStudentId,
    aepGenerating: slice.aepGenerating || {},
    bulkAep: slice.bulkAep || null,
    tiaCheck: slice.tiaCheck || null,
  };
};

const mapDispatchToProps = (dispatch) => ({
  init: (profile) => {
    dispatch(initStudentsRoster(profile));
    dispatch(getAvatars());
    dispatch(resetFilters());
    dispatch(getSchools(profile));
  },
  getHb1416Tracker: (snapshotYear) => {
    dispatch(getHb1416Tracker(snapshotYear));
  },
  updateTracker: (snapshotYear, firebaseId, session, fields) => {
    dispatch(updateHb1416Tracker(snapshotYear, firebaseId, session, fields));
  },
  generateAEP: (snapshotYear, firebaseId, language) => {
    dispatch(generateAEP(snapshotYear, firebaseId, language));
  },
  generateAllAEPs: (snapshotYear, language) => {
    dispatch(generateAllAEPs(snapshotYear, language));
  },
  matchTiaDesignations: (snapshotYear) => {
    dispatch(matchTiaDesignations(snapshotYear));
  },
  selectStudent: (firebaseId) => {
    dispatch(selectStudent(firebaseId));
  },
});

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default Container;
